import React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { FieldRenderProps } from 'react-final-form';

export interface SelectItem {
  label: string | number;
  value: string | number;
}

export default ({
  input: { name, onChange, value, ...restInput },
  meta,
  select,
  selectItems,
  startAdornment,
  endAdornment,
  InputProps,
  textFieldRef,
  CustomInput = TextField,
  ...rest
}: FieldRenderProps<any>) => {
  const hasItems =
    select && Array.isArray(selectItems) && selectItems.length > 0;

  return (
    <CustomInput
      {...rest}
      name={name}
      helperText={meta.touched ? meta.error : undefined}
      error={meta.error && meta.touched}
      InputProps={{
        ...restInput,
        ...InputProps,
        inputRef: textFieldRef,
        startAdornment,
        endAdornment,
      }}
      onChange={onChange}
      value={value}
      select={select}
    >
      {hasItems &&
        selectItems.map((option: SelectItem) => (
          <MenuItem
            style={{ whiteSpace: 'normal' }}
            key={`${name}_${option.value}`}
            value={option.value}
          >
            {option.label}
          </MenuItem>
        ))}
    </CustomInput>
  );
};
